import { useEffect, useState } from 'react';

/**
 * Pending state for a button that sends the user to another site (OAuth,
 * hosted sign-in): it stays on until the page unloads, so the button doesn't
 * look dead or re-enable while the next page loads. Back to a page the
 * browser restores from its back/forward cache clears it.
 */
export function useLeavingPage() {
  const [isLeaving, setIsLeaving] = useState(false);

  useEffect(() => {
    const onPageShow = (event: PageTransitionEvent) => {
      if (event.persisted) setIsLeaving(false);
    };
    window.addEventListener('pageshow', onPageShow);
    return () => window.removeEventListener('pageshow', onPageShow);
  }, []);

  return { isLeaving, startLeaving: () => setIsLeaving(true) };
}
